import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import Vip from './pages/Vip.vue'
import Reports from './pages/Reports.vue'
import Login from './pages/Login.vue'
import Register from './pages/Register.vue'
import Contact from './pages/Contact.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '首页-卓盟科技'
    }
  }, {
    path: '/vip',
    name: 'vip',
    component: Vip,
    meta: {
      title: '会员中心-卓盟科技'
    }
  }, {
    path: '/reports',
    name: 'reports',
    component: Reports,
    meta: {
      title: '卓盟科技-数据报告'
    }
  }, {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录-卓盟科技'
    }
  }, {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: '注册-卓盟科技'
    }
  }, {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      title: '卓盟科技-联系我们'
    }
  }]
})